export const MILLIS_24_HOURS = 1000 * 3600 * 24;
export const MILLIS_1_WEEK = 1000 * 3600 * 24 * 7;
export const MILLIS_1_MIN = 60000;
export const MILLIS_1_HOUR = 3600 * 1000;
export const MILLIS_1_YEAR = 1000 * 3600 * 24 * 365;
export const SQUARE_METERS_TO_SQUARE_FEET = 10.76391;